module.exports = __webpack_public_path__ + "static/our-classes-5-7c652671a6b2027f1be3e59eb9a0e7d4.jpg";